// src/components/Layout.js
import React from 'react';
import Sidebar from './Sidebar';
import './DataTable.css';

const Layout = ({ children }) => {
  return (
    <div className="app-shell flex h-screen">
      {/* Sidebar with independent scroll */}
      <Sidebar />
      
      {/* Main Content with independent scroll */}
      <main className="app-main flex-1 p-6 bg-lightGrey overflow-auto">
        {children}
      </main>
    </div>
  );
};

export default Layout;
